<template>
  <div class="loginContainer">
    <div class="loginLog">
      <!-- <div class="logo" v-if="!shopkey.appCode">
        <img src="@/assets/image/banner.jpg" alt="" />
      </div> -->
      <div class="logoone">
        <img :src="shopkey.logo" alt="" />
      </div>
    </div>
    <div class="logobaner">
      <ForgetModal :shopkey.sync="shopkey" v-if="!code" />
      <LoginModal
        :shopkey.sync="shopkey"
        v-if="showLogin && code"
        @getnext="getnext"
      />
      <RegestModal
        :shopkey.sync="shopkey"
        v-if="!showLogin && code"
        @islogin="islogin"
        @getnext="getnext"
      />
      <div class="loginbottom" v-if="showLogin && code">
        <p>還沒帳號？<span @click="islogin">快去注册</span></p>
        <span @click="code = false">忘記密碼</span>
      </div>
      <div class="aggre" v-if="showLogin && code">
        <p>点击按钮表示您同意并遵循</p>
        <p style="margin-top: 0.1rem">
          <a :href="appUseAgreement" target="_blank">《服务协议》</a>和<a
            :href="appPrivacyAgreement"
            target="_blank"
          >
            《隐私政策》</a
          >
        </p>
      </div>
      <div class="weinxi" v-if="showein" @click="weinligin">
        <img src="@/assets/image/logo_wechat.png" alt="" />
    </div>
      <div class="aggre" v-if="!showLogin && code">
        <p style="padding: 0.3rem 0 0.1rem 0;z-index: 100;position: relative">
          <span @click="islogin">已有账号去登陆</span>
        </p>
      </div>
      <div class="aggre" v-if="!code">
        <!-- <p style="padding: 0.3rem 0 0.1rem 0">
          如有疑問請聯系<span style="color: #097ef7" @click="servecoust"
            ><md-icon name="service"></md-icon>線上客服
          </span>
        </p> -->
        <p style="padding: 0.3rem 0 0.1rem 0;color: #097ef7">
          <span @click="code = true">返回</span>
        </p>
      </div>
    </div>

    <div class="bottomBanner">
      <img src="@/assets/image/login_bg.png" alt="" />
    </div>
     <!-- 国家/地区弹出窗 -->
     <md-selector
      v-model="isPickerShow"
      :data="countryList"
      title="請選擇您要集運的目的地"
      min-height="100px"
      large-radius
      :mask-closable="true"
      class="cheklist"
      @choose="onSelectorConfirm"
      is-check
    ></md-selector>
  </div>
</template>
<script>
  import {
  Toast,
  Selector
} from "mand-mobile";
import LoginModal from "./Modal/LoginModal";
import RegestModal from "./Modal/RegestModal";
import ForgetModal from "./Modal/ForgetModal";
import { getUrlKey } from "../../until/getUrlcode";
import { E, J } from "caniuse-lite/data/agents";
export default {
  components: {
    LoginModal,
    RegestModal,
    ForgetModal,
    [Selector.name]: Selector,
  },
  name: "login",
  data() {
    return {
      isPickerShow:false,
      shopkey: {}, // 店铺参数
      appUseAgreement: "",
      appPrivacyAgreement: "",
      showLogin: true,
      code: true,
      url: "",
      showein:false,
      countryList: []
    };
  },
  activated() {
    let shopkey=JSON.parse(localStorage.getItem('shopkey'))
    console.log(JSON.parse(localStorage.getItem('shopkey')).wxPublicUrl)
    var userAgent = window.navigator.userAgent.toLowerCase();
    if ((userAgent.match(/MicroMessenger/i) == "micromessenger")&&shopkey.wxPublicUrl){
      this.showein=true
    }else{
      this.showein=false
    }
     this.getCountry();
    this.isBindShopDate();
    // 服务条款 隐私政策
    this.appUseAgreement = JSON.parse(
      localStorage.getItem("appUrl")
    ).appUseAgreement;
    this.appPrivacyAgreement = JSON.parse(
      localStorage.getItem("appUrl")
    ).appPrivacyAgreement;
    if (this.shopkey.appCode) {
      this.appUseAgreement += "?shopName=" + this.shopkey.brand;
      this.appPrivacyAgreement += "?shopName=" + this.shopkey.brand;
    }
  },
  methods: {
    islogin() {
      this.showLogin = !this.showLogin;
      this.showLogin ? (document.title = "登录") : (document.title = "注册");
    },
    weinligin(){
       this.isPickerShow=true
    },

    isBindShopDate() {
      if (localStorage.getItem("shopkey")) {
        this.shopkey = JSON.parse(localStorage.getItem("shopkey"));
      } else {
        // 未拥有店铺信息返回重新刷新获取

      }
    },
    onSelectorConfirm({ value, text }) {
      this.registeredPlace = text;
      this.countryId = value;
      console.log(JSON.parse(localStorage.getItem('shopkey')))
      let shopkey=JSON.parse(localStorage.getItem('shopkey'))
      let shopcode='&state=shopCode='+shopkey.appCode;
      let counteyr=',countryId='+this.countryId+'#wechat_redirect&forcePopup=true'
      let url=shopkey.wxPublicUrl+shopcode+counteyr
      console.log(url)
       window.location.href=url

    },
    getCountry() {
      const par = {
        parentId: 0
      };
      this.http.APIASK(this.ports.country, "get", par).then(res => {
        let sunenr=JSON.parse(JSON.stringify(res))
        const data = res.map(function(item) {
          return {
            text: item.name,
            value: item.id
          };
        });
        for (let i in sunenr) {
          sunenr[i].text = sunenr[i].name;
          sunenr[i].label = sunenr[i].name;
          sunenr[i].value = sunenr[i].id;
        }
        this.countryList = sunenr;
        console.log(data)
        var v = data.find((value, index, arr) => {
          return value.value == this.$route.query.id? this.$route.query.id : localStorage.getItem("firconteid");
        });
        // this.url = "https://ysftest4.qiyukf.com/client?k=2ae0e7640493795d063e35538c69a050&templateId=4474201&wp=1&sid=" + v.customerServiceId;
      });
    },
    servecoust() {
      window.location.href = this.url;
    },
    getnext() {
      switch (
        parseInt(this.$route.query.index) ||
        getUrlKey("index", window.location.href)
      ) {
        case 0:
          this.$router.replace({
            name: "Address",
            query: { id: this.$route.query.id }
          });
          break;
        case 1:
          this.$router.replace({
            name: "Predition",
            query: { id: this.$route.query.id }
          });
          break;
        case 2:
          this.$router.replace({
            name: "Chongzhi",
            query: { id: this.$route.query.id }
          });
          break;
        case 3:
          this.$router.go(-1);
          break;
        case 4:
          this.$router.replace({
            name: "Message",
            query: { id: this.$route.query.id }
          });
          break;
        case 5:
          this.$router.replace({
            name: "Address",
            query: { id: this.$route.query.id }
          });
          break;
        case 6:
          this.$router.replace({
            name: "Predition",
            query: { id: this.$route.query.id }
          });
          break;
        case 7:
          this.$router.replace({
            name: "Package",
            query: {
              id: this.$route.query.id,
              packindecx: this.$route.query.packindecx
            }
          });
          break;
        case 8:
          this.$router.replace({
            name: "Order",
            query: { id: this.$route.query.id }
          });
          break;
        case 9:
          this.$router.go(-1);
          break;
        case 11:
          this.$router.replace({
            name: "UseRepert",
            query: { id: this.$route.query.id }
          });
          break;
        case 12:
          this.$router.replace({
            name: "Transaction",
            query: { id: this.$route.query.id }
          });
          break;
        case 13:
          this.$router.replace({
            name: "Coup",
            query: { id: this.$route.query.id }
          });
          break;
        case 14:
          this.$router.replace({
            name: "AddressUser",
            query: { id: this.$route.query.id }
          });
          break;
        default:
          this.$router.replace({
             name: "Home",
          })
      }
    }
  }
};
</script>

<style lang="less">
.loginLog {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  // background-color: #e32c1a;

  .logo {
    width: 1.5rem;
    height: 1.5rem;

    img {
      width: 100%;
    }
  }
  .logoone {
    width: 3.5rem;
    display: flex;
    align-items: center;
    justify-content: center;
    img {
      width: 100%;
      object-fit: contain;
      padding: 0.5rem 0;
    }
  }
}

.logobaner {
  width: 90%;
  margin-left: 5%;
  background-color: white;
  z-index: 1;
  border-radius: 0.1rem;
}

.loginbottom {
  height: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 90%;
  margin-left: 5%;

  span {
    font-size: 0.28rem;
    color: rgba(48, 125, 253, 100);
  }

  p {
    font-size: 0.28rem;
  }
}

.aggre {
  font-size: 0.28rem;
  color: #333333;
  padding-bottom: 0.2rem;

  p {
    a {
      color: rgba(48, 125, 253, 100);
      text-decoration: none;
    }
  }
}

.bottomBanner {
  width: 100%;
  position: absolute;
  bottom: 0;
  display: flex;
  justify-content: flex-start;
  align-items: flex-end;

  img {
    width: 100%;
    height: auto;
  }
}
.weinxi img{
  width: 1rem;
}
.md-field{
  padding: 0.1rem 0.3rem;
}
</style>
